var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 116,
    viewBox: "0 0 257 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1959 0.306946H71.3625L124.68 93.1634H93.233L62.2244 39.3501L31.4351 93.2125H0L53.1959 0.306946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.302 81.6469L172.113 0H203.633L183.542 35.1511L194.386 54.1202L225.394 0H257L203.548 93.2494H185.309L167.739 62.6655L150.169 93.2494H131.942L125.302 81.6469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1354 116H5.93367C3.28971 116 1.3037 114.907 1.3037 111.641C1.3037 108.376 3.28971 107.221 5.93367 107.221H12.1354C13.5244 107.221 14.6941 107.381 15.7297 107.602C15.7053 105.932 15.1814 104.913 12.8177 104.913H9.19902C6.66472 104.913 3.18005 105.515 2.31498 105.871L2.58303 102.63C3.42374 102.384 6.64035 101.758 9.41833 101.758H13.2076C17.3502 101.758 19.5555 103.403 19.5555 107.406V111.715C19.5555 112.157 19.7139 112.157 19.9942 112.157V116C17.7401 116 16.4608 115.73 15.9612 114.514H15.9125C14.9377 115.533 13.7315 116 12.1598 116H12.1354ZM15.7297 110.598C15.0718 110.487 13.963 110.377 13.171 110.377H7.26174C5.6047 110.377 5.19044 110.757 5.19044 111.605C5.19044 112.403 5.6047 112.845 7.26174 112.845H13.171C13.9874 112.845 15.1814 112.685 15.7297 112.513V110.598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7153 95.1524H35.7726V98.9953H31.7153V95.1524ZM31.8493 102.016H35.663V115.73H31.8493V102.016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9861 101.733H61.7248L62.1635 104.889H55.1089C52.4649 104.889 51.2952 106.043 51.2952 107.983V115.718H47.4816V102.003H51.2952L51.2465 103.452L51.2952 103.477C52.3796 102.494 53.9635 101.721 55.9739 101.721L55.9861 101.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.099 102.016L99.118 112.931L105.356 102.016H109.816L101.567 115.73H96.608L90.8328 105.331L84.8381 115.73H79.8792L71.9352 102.016H76.3702L82.3891 112.931L88.6518 102.016H93.0868H93.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69 101.733H133.185C137.132 101.733 140.776 103.133 140.776 108.867C140.776 114.6 137.132 116 133.185 116H127.69C123.742 116 120.099 114.662 120.099 108.891C120.099 103.121 123.742 101.733 127.69 101.733ZM127.86 112.845H133.026C135.366 112.845 136.889 111.42 136.889 108.867C136.889 106.178 135.366 104.889 133.026 104.889H127.86C125.521 104.889 123.998 106.178 123.998 108.867C123.998 111.555 125.521 112.845 127.86 112.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.989 101.733H166.728L167.166 104.889H160.112C157.468 104.889 156.298 106.043 156.298 107.983V115.718H152.484V102.003H156.298L156.249 103.452L156.298 103.477C157.382 102.494 158.966 101.721 160.977 101.721L160.989 101.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.351 115.73V95.1647H182.165V109.37L192.022 102.016H198.224L189.488 108.302L199.04 115.73H193.192L186.551 110.377L182.165 113.532V115.73H178.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.055 116H216.926C212.979 116 209.336 114.662 209.336 108.891C209.336 103.121 212.979 101.733 216.926 101.733H223.055C228.306 101.733 229.829 104.287 229.829 109.689H213.259C213.454 111.752 214.514 112.845 216.829 112.845H223.177C224.834 112.845 225.894 112.243 225.894 111.199H229.817C229.817 114.269 226.796 116 223.067 116H223.055ZM225.772 107.086C225.504 105.773 224.761 104.889 222.86 104.889H216.817C215.074 104.889 213.929 105.601 213.466 107.086H225.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.031 101.733H255.769L256.208 104.889H249.153C246.509 104.889 245.34 106.043 245.34 107.983V115.718H241.526V102.003H245.34L245.291 103.452L245.34 103.477C246.424 102.494 248.008 101.721 250.018 101.721L250.031 101.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4902 0H110.084L135.658 44.5068L119.868 72.0334L78.4902 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d532fb8a2e1f91b14b3b37f565fd844b.svg";
export { ForwardRef as ReactComponent };